import {
  createAsyncActionIsLoadedSelector,
  createAsyncActionIsLoadingSelector,
  createAsyncActionErrorSelector,
} from '../asyncAction';
import type { RootState } from '../rootReducer';
import {
  getProcessInstancesRequest, getProcessInstancesCountRequest, ProcessInstancesState,
} from './slice';

export const selectProcessInstancesState = (state: RootState): ProcessInstancesState => state.processInstances;

export const selectProcessInstances = (state: RootState) => state.processInstances.list;
export const selectProcessInstancesIsLoading = createAsyncActionIsLoadingSelector(getProcessInstancesRequest.type);
export const selectProcessInstancesIsLoaded = createAsyncActionIsLoadedSelector(getProcessInstancesRequest.type);

export const selectProcessInstancesCount = (state: RootState) => state.processInstances.count;

export const selectProcessInstancesFilterParams = (
  state: RootState,
) => state.processInstances.filterParams;

export const selectProcessInstancesCountIsLoading = (
  createAsyncActionIsLoadingSelector(getProcessInstancesCountRequest.type)
);
export const selectProcessInstancesCountError = (
  createAsyncActionErrorSelector(getProcessInstancesCountRequest.type)
);
export const selectProcessInstancesError = (
  createAsyncActionErrorSelector(getProcessInstancesRequest.type)
);
